import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import FloatingElements from '@/components/FloatingElements';
import { useBooking } from '@/context/BookingContext';
import clinic from '@/data/clinic';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function StickyMobileCTA() {
  const { openBooking } = useBooking();
  return (
    <div className="sticky-cta" data-testid="sticky-cta">
      <a href={`tel:${clinic.phoneE164}`} className="sticky-cta-btn sticky-cta-call">📞 Call</a>
      <a href={clinic.waLink()} className="sticky-cta-btn sticky-cta-wa" target="_blank" rel="noopener noreferrer">💬 WhatsApp</a>
      <button className="sticky-cta-btn sticky-cta-book" onClick={openBooking}>📅 Book</button>
    </div>
  );
}

const Layout = () => {
  const { openBooking } = useBooking();
  return (
    <div className="app">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <ScrollToTop />
      <Header onBook={openBooking} />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
      <FloatingElements />
      <StickyMobileCTA />
    </div>
  );
};

export default Layout;
